<template>
  <v-app>
    <snackbar ref="snackbar"></snackbar>

    <v-main class="auth-main">
      <div class="d-flex flex-row pa-4 white--text" style="position: absolute;">
        <icon-base
          width="46"
          height="46"
        >
          <icon-logo/>
        </icon-base>
        <span class="text-uppercase font-weight-light ma-3">TrueHeroesFilms</span>
      </div>

      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <router-view></router-view>
        </v-row>
        <v-footer app class="transparent white--text">
          <span>&copy;</span>
          <span class="ml-1">The Digest</span>
        </v-footer>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Snackbar from '@/components/Snackbar'
import IconBase from '@/components/icons/IconBase.vue'
import IconLogo from '@/components/icons/IconLogo.vue'

export default {
  components: {
    IconBase,
    IconLogo,
    Snackbar
  }
}
</script>

<style scoped>
  .auth-main {
    background-image:
        linear-gradient(
          rgba(23, 122, 151, 0.9),
          rgba(23, 122, 151, 0.9)
        ),
        url('../assets/img/auth-layout-bg.png');
    background-size: cover;
    background-position: center;
  }
</style>
